var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3556 10.0664V14.2687C10.4248 14.0199 9.75205 13.1721 9.75205 12.1676C9.74283 11.1631 10.4248 10.3152 11.3556 10.0664Z",
    fill: "#919AA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00098 14.1492V10.3984C4.96862 10.4722 5.7335 11.2831 5.7335 12.2784C5.74272 13.2645 4.97783 14.0755 4.00098 14.1492Z",
    fill: "#919AA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70093 12.1581C8.70093 13.7432 9.85288 15.0703 11.355 15.3375V17.8718C11.355 18.351 10.968 18.7381 10.4888 18.7381H6.12056C4.95017 18.7381 4.00098 17.7889 4.00098 16.6185V15.1993C5.5492 15.1256 6.78408 13.8354 6.78408 12.278C6.78408 10.7113 5.5492 9.43033 4.00098 9.34739V7.92818C4.00098 6.7578 4.95017 5.80859 6.12056 5.80859H10.4888C10.968 5.80859 11.355 6.19565 11.355 6.67486V8.98798C9.84367 9.25523 8.70093 10.5731 8.70093 12.1581Z",
    fill: "#919AA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6543 14.2234V10.1133C13.5021 10.4082 14.1104 11.2192 14.1104 12.1684C14.1104 13.1176 13.4929 13.9193 12.6543 14.2234Z",
    fill: "#919AA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 10.6914V13.8524C19.1237 13.8524 18.4141 13.1428 18.4141 12.2765C18.4141 11.401 19.1237 10.6914 19.9991 10.6914Z",
    fill: "#919AA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 7.92818V9.64229C18.8845 9.64229 17.8615 10.3335 17.5113 11.3933C16.9123 13.2087 18.2578 14.8952 19.9996 14.8952V16.6093C19.9996 17.7797 19.0504 18.7289 17.88 18.7289H13.5118C13.0326 18.7289 12.6455 18.3418 12.6455 17.8626V15.3099C14.0831 14.9781 15.1522 13.6972 15.1522 12.1581C15.1522 10.6191 14.0831 9.33817 12.6455 9.01563V6.67486C12.6455 6.19565 13.0326 5.80859 13.5118 5.80859H17.88C19.0504 5.80859 19.9996 6.7578 19.9996 7.92818Z",
    fill: "#919AA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.b939a23f938ed4ab636fa1e490a2cb4e.svg";
export { ForwardRef as ReactComponent };